export const API_URL = process.env.REACT_APP_API_URL;

export const IDENTITY_URL = 'https://api.perfectstrokeproject.com';
export const CLIENT_ID = 'client';
export const CLIENT_SECRET = 'secret';
export const GRANT_TYPE = 'password';
export const SCOPE = 'perfectStrokeApi offline_access profile openid email';

export const BUCKET_URL = 'https://dns.perfectstrokeproject.com';

export const PAINT_TYPES = [
  'Acrylic',
  'Water Color',
  'Oil',
  'Gouache',
  'Ink',
  'Pastel',
];

export const OPACITY_TYPES = [
  'Opaque',
  'Semi-Opaque',
  'Semi',
  'Semi-Transparent',
  'Transparent',
];

export const QUALITY_TYPES = ['Artist Grade', 'Student Grade'];
